/* =========================================================
   OVERTOP — Meta Pixel Thin AddToCart Killer (Horizon)
   ---------------------------------------------------------
   Purpose: Block Shopify Web Pixel's THIN AddToCart events
   that fire alongside your own fbq() calls and inflate
   ATC counts in Events Manager.

   Theme-agnostic. Identical behavior across Impulse / Horizon.
   Drop in /assets/. Loaded EARLY by ot-scripts.liquid.
   ========================================================= */

(function () {
  function looksLikeThinCsEstATC(payloadText) {
    if (!payloadText) return false;
    var t = String(payloadText);

    // Must be AddToCart
    var isATC =
      t.indexOf('AddToCart') !== -1 ||
      t.indexOf('"ev":"AddToCart"') !== -1 ||
      t.indexOf('"event_name":"AddToCart"') !== -1;
    if (!isATC) return false;

    // Must contain cs_est marker
    if (t.indexOf('cs_est') === -1) return false;

    // If it carries real ecommerce markers, DO NOT drop
    var hasEcom =
      t.indexOf('"value"') !== -1 ||
      t.indexOf('"currency"') !== -1 ||
      t.indexOf('"content_ids"') !== -1 ||
      t.indexOf('"contents"') !== -1 ||
      t.indexOf('"num_items"') !== -1;

    return !hasEcom;
  }

  // --- fetch() wrapper ---
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');

        var isMeta =
          url.indexOf('facebook.com/tr') !== -1 ||
          url.indexOf('graph.facebook.com') !== -1 ||
          url.indexOf('connect.facebook.net') !== -1 ||
          url.indexOf('facebook.net') !== -1;

        if (isMeta && init && init.body) {
          var bodyText = '';
          if (typeof init.body === 'string') bodyText = init.body;
          else if (init.body instanceof URLSearchParams) bodyText = init.body.toString();
          else if (init.body && typeof init.body.text === 'function') {
            return init.body.text().then(function (txt) {
              if (looksLikeThinCsEstATC(txt)) {
                return new Response('', { status: 204 });
              }
              return _fetch.apply(window, [input, init]);
            });
          }

          if (looksLikeThinCsEstATC(bodyText)) {
            return Promise.resolve(new Response('', { status: 204 }));
          }
        }
      } catch (e) {}
      return _fetch.apply(window, arguments);
    };
  }

  // --- sendBeacon() wrapper ---
  if (navigator && typeof navigator.sendBeacon === 'function') {
    var _beacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = function (url, data) {
      try {
        var u = String(url || '');
        var isMeta =
          u.indexOf('facebook.com/tr') !== -1 ||
          u.indexOf('graph.facebook.com') !== -1 ||
          u.indexOf('facebook.net') !== -1 ||
          u.indexOf('connect.facebook.net') !== -1;

        if (isMeta && data && typeof data === 'string') {
          if (looksLikeThinCsEstATC(data)) return true; // pretend sent
        }
      } catch (e) {}
      return _beacon.apply(navigator, arguments);
    };
  }
})();
